import React from "react";
import { Row, Col } from "react-bootstrap";
import InputSearch from "../inputs/InputSelectSearch";
import InputNumber from "../inputs/InputNumber";
import { jurisprudenceTypes } from "../../libs/jurisprudenceData/Jurisprudences";

export const FormTesis = ({
    values,
    errors,
    touched,
    onChange,
    handleBlur,
    materias,
    distritos,
    regiones,
    areas,
}: {
    values: any;
    errors: any;
    touched: any;
    onChange: any;
    handleBlur: any;
    materias: any;
    distritos: any;
    regiones: any;
    areas: any;
}) => {
    return (
        <div>
            <Row className="d-flex justify-content-around mt-3">
                <Col xs={12} md={3}>
                    <InputSearch label="Región" name="region" value={values.region as string} touched={touched.region} error={errors.region} values={regiones} labelVal="name" valueVal="_id" onChangeMethod={onChange} onBlurMethod={handleBlur} />
                </Col>
                <Col xs={12} md={3}>
                    <InputSearch
                        label="Distritos"
                        name="distrito"
                        value={values.distrito}
                        touched={touched.distrito}
                        error={errors.distrito}
                        values={distritos}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        disabled={!values.region || regiones.length === 0 ? true : false}
                        required
                    />
                </Col>
                <Col xs={12} md={3}>
                    <InputSearch
                        label="Órgano emisor"
                        name="area"
                        value={values.area as string}
                        touched={touched.area}
                        error={errors.area}
                        values={areas}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        disabled={!values.distrito || areas.length === 0 ? true : false}
                    />
                </Col>
            </Row>
            <Row className="d-flex justify-content-around mt-3">
                <Col xs={12} md={3}>
                    <InputSearch label="Materias" name="subject" value={values.subject} touched={touched.subject} error={errors.subject} values={materias} labelVal="name" valueVal="_id" onChangeMethod={onChange} onBlurMethod={handleBlur} required />
                </Col>
                <Col xs={12} md={3}>
                    <InputNumber label="Año" name="year" value={values.year} touched={touched.year} error={errors.year} onChangeMethod={onChange} onBlurMethod={handleBlur} disableSep maxLength={4} />
                </Col>
                <Col xs={12} md={3}>
                    <InputSearch
                        label="Tipo de Jurisprudencia"
                        name="jurisprudenceType"
                        value={values.jurisprudenceType}
                        touched={touched.jurisprudenceType}
                        error={errors.jurisprudenceType}
                        values={jurisprudenceTypes}
                        labelVal="name"
                        valueVal="id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                    />
                </Col>
            </Row>
        </div>
    );
};
